export enum TableColumnStickType {
    Left = "Left",
    Middle = "Middle",
    Right = "Right"
}
